module.exports = __webpack_public_path__ + "static/media/marginalia-no-comments.2b9ac84a.svg";